module.exports = __webpack_public_path__ + "static/media/command.74f0e940.svg";